import React, {useEffect, useState} from "react";
import {Breadcrumb} from "@themesberg/react-bootstrap";
import Subscription from "../libs/Subscription";
import moment from "moment-timezone";
import {faHome} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useHistory} from "react-router-dom";
import CustomSpinner from "../../components/CustomSpinner";
import Alert from "react-bootstrap/Alert";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {numberFormatter} from "../../libs/numberFormatter";
import {selectActiveCompanyId, selectResellerinfo, selectUser, selectUserType} from "../../store/reducers/userCompany";
import {Spinner} from "react-bootstrap";
import resellerAction from "../../reseller/libs/ResellerAction";

function CompanySubscription() {
  const history = useHistory();
  const {t} = useTranslation();
  const user = useSelector(selectUser);

  // console.log(useSelector((state) => state.userCompany.user?.user?.reseller), "useSelector((state) => state.userCompany.user?.user?.reseller)");
  // const userType = useSelector((state) => state.userCompany.user.userType);
  // const user = useSelector((state) => state.userCompany.user) ;
  // console.log(user, "user");

  const [subscription, setSubscription] = useState(null);
  const [payments, setPayments] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadingPayment, setLoadingPayment] = useState(true);
  const [resellerUser, setResellerUser] = useState("");
  const companyId = useSelector(selectActiveCompanyId);
  const checkGoldSubscrpition = subscription?.subscription_num_invoices === -1;

  useEffect(() => {
    const firstName = user?.user?.first_name;
    const lastName = user?.user?.last_name;
    setResellerUser(firstName + " " + lastName);

    if (user?.userType === "reseller") {
      setSubscription(user?.companySubscription);
      resellerPayments()
      setLoading(false)
    } else {
      getCompanySubscription();
      companySubscriptionPayments();
    }
    //eslint-disable-next-line
  }, []);

  const getCompanySubscription = () => {
    Subscription.getCompanySubscription(companyId)
        .then((res) => {
          if (res.subscription) {
            setSubscription(res.subscription);
            setLoading(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
  };

  const companySubscriptionPayments = () => {
    setLoadingPayment(true);
    Subscription.companySubscriptionPayments(companyId)
        .then((res) => {
          setPayments(res.payments);
          setLoadingPayment(false);
        })
        .catch((error) => {
          setLoadingPayment(false);
          console.log(error);
        });
  };

    const resellerPayments = () => {
        setLoadingPayment(true);
        resellerAction.resellerpayment(companyId)
            .then((res) => {
                setPayments(res.payments);
                setLoadingPayment(false);
            })
            .catch((error) => {
                setLoadingPayment(false);
                console.log(error);
            });
    };


    return (
      <>
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
          <div className="d-block mb-4 mb-md-0">
            <Breadcrumb
                className="d-none d-md-inline-block"
                listProps={{className: "breadcrumb-dark breadcrumb-transparent"}}
            >
              <Breadcrumb.Item href="/">
                <FontAwesomeIcon icon={faHome}/>
              </Breadcrumb.Item>
              <Breadcrumb.Item active>
                {t("Company subscription")}
              </Breadcrumb.Item>
            </Breadcrumb>

            <h4>{t("Company subscription")}</h4>
            <p className="mb-0">
              {t("Details about the subscription of your company and payment history")}
            </p>
          </div>
        </div>
        <>
          {loading ? (
              <CustomSpinner/>
          ) : (
              <>
                {user?.reseller ? (
                    <Alert variant="warning">
                      {t("You have a subscription to the services of ")}
                      <u className="fw-bold">{resellerUser}</u> ,
                      {t("please contact them if you need more information about your subscription")}
                      .
                    </Alert>
                ) :    <div className="row mt-4 justify g-3">
                    {user?.userType !== "reseller" &&
                      <div className="col-12 col-md-4">
                        <h5>{t("Subscription Details")}</h5>
                        {subscription && (
                            <div className="card shadow mb-4">
                              <div className="card-body p-3 d-flex flex-column">
                              <h6 className="text-center mb-2">Plan</h6>
                              <h2 className="text-center  h3 mb-2">
                                {subscription.subscription_name}
                              </h2>
                              <h6 className="h6 text-center mb-2">{t("Monthly")}</h6>
                              <p className="text-center mb-2">
                                {checkGoldSubscrpition ? "Unlimited" : subscription.subscription_num_invoices} {t("invoices")}
                              </p>
                              <h4 className="text-center mb-3">
                                {numberFormatter.format(
                                    subscription.subscription_price / 100
                                )}
                              </h4>
                              <button
                                  className="subscription-btn w-100"
                                  onClick={() => {
                                    history.push(
                                        user?.userType === "reseller"
                                            ? "/reseller/change-subscription"
                                            : "/change-subscription"
                                    );
                                  }}
                              >
                                {t("Change Subscription")}
                              </button>
                              </div>
                            </div>
                        )}
                      </div>}
                      <div className="col-12 col-md-8">
                        <h5>{t("Payment Details")}</h5>
                          {loadingPayment ? <Spinner size="sm" animation="border" role="status"></Spinner> :
                              <>
                                {payments ? (
                                    <div className="table-responsive bg-white rounded shadow-sm">
                                      <table className="table table-hover mb-0">
                                        <thead>
                                        <tr>
                                          <th>{t("Date")}</th>
                                          <th className="text-center">{t("status")}</th>
                                          <th className="text-center">{t("Amount")}</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {payments.map((payment) => {
                                          return (
                                              <tr key={payment.id}>
                                                <td>
                                                  {moment
                                                      .tz(payment.createdAt, "Europe/Amsterdam")
                                                      .format("DD-MM-YYYY")}
                                                </td>
                                                <td className="text-center">
                                                  {payment.status === "paid" ? (
                                                      <i
                                                          className="fa fa-check text-success"
                                                          aria-hidden="true"
                                                      ></i>
                                                  ) : (
                                                      <i
                                                          className="fa fa-times text-danger"
                                                          aria-hidden="true"
                                                      ></i>
                                                  )}
                                                </td>
                                                <td className="text-center">
                                                  €{payment.amount.value}
                                                </td>
                                              </tr>
                                          );
                                        })}
                                        </tbody>
                                      </table>
                                    </div>
                                ) : (
                                    <Alert variant="warning">
                                      {t(
                                          "There are no payments registered for your account yet"
                                      )}
                                    </Alert>
                                )}
                             </>
                          }
                      </div>
                    </div>

                }
              </>
          )}
        </>
      </>
  );
}

export default CompanySubscription;
